<template>
  <div
    class="cover-container"
    :class="'is-col-' + gridColumns"
    v-if="avatarList && avatarList.length"
  >
    <div
      class="img-content"
      @click="(e) => e.stopPropagation()"
      v-for="(img, imgIndex) in avatarList"
      :key="imgIndex"
    >
      <!-- 列表格子只有 138px，显示缩略图；preview-src-list 保持原图数组 -->
      <el-image
        :src="contentThumb(img)"
        fit="cover"
        alt="图片"
        :preview-src-list="avatarList"
        @error="onContentThumbError(img)"
      />
    </div>
  </div>
</template>
<script>
import contentImageMixin from '@/mixins/contentImageMixin'
export default {
  mixins: [contentImageMixin],
  props: ['avatarList'],
  computed: {
    // 移动端按张数决定列数：1 张单图、2/4 张两列（避免 4 张排成 3+1 的孤图）、其余三列。
    // 桌面端仍是 138px 固定方图流，这个 class 只影响 <768px 的媒体查询。
    gridColumns () {
      const count = (this.avatarList || []).length
      if (count === 1) return 1
      if (count === 2 || count === 4) return 2
      return 3
    }
  }
}
</script>
<style scoped lang="scss">
.cover-container {
  width: 100%;
  max-width: calc((138px + 8px) * 4);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0;

  .img-content {
    position: relative;
    width: 138px;
    height: 138px;
    border-radius: 8px;
    overflow: hidden;
    background: #f2f3f5;
  }
  .el-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    ::v-deep img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  // ---------- 移动端：宽度自适应的九宫格 ----------
  @media screen and (max-width: $bp-md - 1px) {
    max-width: 100%;
    display: grid;
    gap: 4px;

    &.is-col-1 {
      grid-template-columns: minmax(0, 72%);
    }
    &.is-col-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    &.is-col-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .img-content {
      width: 100%;
      height: 0;
      // 用 padding-top 撑高度：比 aspect-ratio 兼容更多老版本微信内核
      padding-top: 100%;
      border-radius: 6px;
    }

    .el-image {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 6px;
    }
  }
}
</style>
